import { feedbackAnswerSlice } from '../store/slices/feedbackSlice';

export const {
	updateSessionDetail: updateSessionDetailForm,
	updateSessionFeedback: updateSessionFeedbackForm,
	resetSessionFeedback: resetSessionFeedbackForm,
} = feedbackAnswerSlice.actions;
